import styled from 'styled-components';
import { media } from 'utils/style';
import Container from './Container';

export default styled(Container)`
  height: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;

  ${media.greaterThan('tablet')`
    padding: 0;
    padding-top: 56px;
  `}
`;
